// extracted by mini-css-extract-plugin
export default {"page-loader":"page-loader_page-loader__ngKLS","img":"page-loader_img__zwbJV"};